<template>
  <nav class="navbar navbar-expand-lg navbar-dark navbar-custom">
    <div class="container collapse navbar-collapse">
      <a class="navbar-brand" href="/">Mimicando</a>
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <router-link to="/dashboard/packs" class="nav-link">
            Pacotes
            <span class="sr-only">(current)</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/dashboard/add-pack" class="nav-link">Adicionar pacote</router-link>
        </li>
      </ul>
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link" href="#" @click="logout()" v-if="!loggingOut">
            Sair
          </a>
          <div class="spinner-border text-primary" role="status" v-else>
            <span class="sr-only">Loading...</span>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'Navbar',
  data () {
    return {
      loggingOut: false
    }
  },
  methods: {
    logout () {
      this.loggingOut = true

      firebase.auth().signOut().then(() => {
        this.$router.push({
          name: 'login'
        })
      })
    }
  }
}
</script>

<style>
  nav {
    margin-bottom: 16px;
  }
  .navbar-custom {
    background-color: #6D4C1E;
  }
  /* change the brand and text color */
  .navbar-custom .navbar-brand,
  .navbar-custom .navbar-text {
      color: rgba(255,255,255,.8);
  }
  /* change the link color */
  .navbar-custom .navbar-nav .nav-link {
      color: rgba(255,255,255,.5);
  }
  /* change the color of active or hovered links */
  .navbar-custom .nav-item.active .nav-link,
  .navbar-custom .nav-item:hover .nav-link {
      color: #ffffff;
  }
</style>
